// function testIfValidURL(str) {
//     const pattern = new RegExp('^https:\\/\\/' + // protocol
//       '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
//       '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
//       '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
//       '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
//       '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

//     return !!pattern.test(str);
//   }

const regex = /^(https):\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i; //eslint-disable-line

export function validateImgUrl(url: string) {
  if (!url.trim()) return;
  if (!/^https/.test(url)) {
    return 'URL should be https://';
  }

  if (!regex.test(url)) {
    return 'Invalid URL';
  }

  if (!url.match(/\.(jpeg|jpg|gif|png)$/)) {
    return 'Supported file types are: .jpg, .png, .gif';
  }
}

export function isValidateImageUrl(url: string) {
  if (/^https/.test(url) && regex.test(url) && url.match(/\.(jpeg|jpg|gif|png)$/)) return true;
}

export function validateUrl(url: string) {
  if (!url.trim()) return;
  if (!/^https/.test(url)) {
    return 'URL should be https://';
  }

  if (!regex.test(url)) {
    return 'Invalid URL';
  }

  //Invalid file type. Supported file types are: .jpg, .png,
}

export function isValidateUrl(url: string) {
  if (/^https/.test(url) && regex.test(url)) return true;
}

export function isNotValidEmail(email: string) {
  if (
    !email.match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    )
  )
    return true;
}
